/* eslint-disable */
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.variables = {};
    Blockly.Blocks.variables.num_style = 'num_variables_blocks';
    Blockly.Blocks.variables.text_style = 'text_variables_blocks';
    Blockly.Blocks.variables.bool_style = 'bool_variables_blocks';
    Blockly.Scrollbar.scrollbarThickness = 20;
    if (Blockly.Touch.TOUCH_ENABLED) {
      Blockly.Scrollbar.scrollbarThickness = 30;
    }
    Blockly.Flyout.prototype.CORNER_RADIUS = 24;
    Blockly.Flyout.prototype.SCROLLBAR_MARGIN = 15;
    Blockly.Blocks.variables_get_number = {
        init: function() {
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.variables.num_style);
            this.setTooltip(Blockly.Msg.VARIABLES_GET_TOOLTIP);
            this.appendDummyInput()
                .appendField(new Blockly.FieldVariable(Blockly.Msg.VARIABLES_DEFAULT_NAME, null, ['Number'], 'Number'), "VAR")
            this.setOutput(true, "Number");
        }
    };
    Blockly.Blocks.variables_set_number = {
        init: function() {
            this.setStyle(Blockly.Blocks.variables.num_style);
            this.setTooltip(Blockly.Msg.VARIABLES_SET_TOOLTIP);
            this.appendValueInput("VALUE")
                .appendField(Blockly.Msg.VARIABLES_SET)
                .appendField(new Blockly.FieldVariable(Blockly.Msg.VARIABLES_DEFAULT_NAME, null, ['Number'], 'Number'), "VAR")
                .appendField("=")
                .setCheck("Number");
            this.contextMenuMsg_ = Blockly.Msg.VARIABLES_SET_CREATE_GET;
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
        }
    };
    Blockly.Blocks.variables_get_text = {
        init: function() {
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.variables.text_style);
            this.setTooltip(Blockly.Msg.VARIABLES_GET_TOOLTIP);
            this.appendDummyInput()
                .appendField(new Blockly.FieldVariable(Blockly.Msg.VARIABLES_DEFAULT_NAME_TEXT, null, ['String'], 'String'), "VAR")
            this.setOutput(true, "String");
        }
    };
    Blockly.Blocks.variables_set_text = {
      init: function() {
        this.setStyle(Blockly.Blocks.variables.text_style);
        this.setTooltip(Blockly.Msg.VARIABLES_SET_TOOLTIP);
        this.appendValueInput("VALUE")
            .appendField(Blockly.Msg.VARIABLES_SET)
            .appendField(new Blockly.FieldVariable(Blockly.Msg.VARIABLES_DEFAULT_NAME_TEXT, null, ['String'], 'String'), "VAR")
            .appendField("=")
            .setCheck("String");
        this.setPreviousStatement(true);
        this.setNextStatement(true);
      }
    };
    Blockly.Blocks.variables_get_bool = {
        init: function() {
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.variables.bool_style);
            this.setTooltip(Blockly.Msg.VARIABLES_GET_TOOLTIP);
            this.appendDummyInput()
                .appendField(new Blockly.FieldVariable(Blockly.Msg.VARIABLES_DEFAULT_NAME_BOOL, null, ['Bool'], 'Bool'), "VAR")
            this.setOutput(!0, "Boolean");
        }
    };
    Blockly.Blocks.variables_set_bool = {
        init: function() {
            this.setStyle(Blockly.Blocks.variables.bool_style);
            this.setTooltip(Blockly.Msg.VARIABLES_SET_TOOLTIP);
            this.appendValueInput("VALUE")
                .appendField(Blockly.Msg.VARIABLES_SET)
                .appendField(new Blockly.FieldVariable(Blockly.Msg.VARIABLES_DEFAULT_NAME_BOOL, null, ['Bool'], 'Bool'), "VAR")
                .appendField("=")
                .setCheck("Boolean");
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
        }
    };
}